<template>
  <section>
    <!--工具条-->
    <CustomerInterfaceToolbar :buttonList="buttonList" @callFunction="callFunction"></CustomerInterfaceToolbar>

    <!--列表-->
    <el-table :data="customerInterfaceList" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="100"></el-table-column>
      <el-table-column fixed="left" label="操作" width="130">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="CustomName" label="客户名称" width="230" sortable></el-table-column>
      <el-table-column prop="InterfaceUrl" label="接口Url" width="230" sortable></el-table-column>
      <el-table-column prop="Enabled" label="状态" width="100" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" disable-transitions>{{ scope.row.Enabled ?
            "正常" : "禁用" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="InterfaceDescribe" label="接口描述" width="300" sortable></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属客户" prop="CustomerId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.CustomerId" placeholder="请选择所属客户">
                <el-option
                  v-for="item in customerList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CustomName"
                >
                  <span style="float: left">{{ item.CustomName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择客户状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="接口Url" prop="InterfaceUrl" label-width="110px">
            <el-input v-model="addForm.InterfaceUrl" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="接口描述" prop="InterfaceDescribe" label-width="110px">
            <el-input rows="2" type="textarea" v-model="addForm.InterfaceDescribe" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="所属客户" prop="CustomerId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.CustomerId" placeholder="请选择所属客户">
                <el-option
                  v-for="item in customerList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.CustomName"
                >
                  <span style="float: left">{{ item.CustomName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择客户状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="接口Url" prop="InterfaceUrl" label-width="110px">
            <el-input v-model="editForm.InterfaceUrl" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="接口描述" prop="InterfaceDescribe" label-width="110px">
            <el-input rows="2" type="textarea" v-model="editForm.InterfaceDescribe" auto-complete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getCustomerInterfaceListPage, addCustomerInterface, editCustomerInterface, removeCustomerInterface, getCustomerListPage } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import CustomerInterfaceToolbar from "../../components/QueryToolbar/CustomerInterfaceToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { CustomerInterfaceToolbar, OperateDataLog },
  data() {
    return {
      filters: {
        customerId: "",
        enabled: "true"
      },
      entityName: 'CustomerInterface', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      customerList: [], //客户列表
      customerInterfaceList: [], //客户接口列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      editFormRules: {
        CustomerId: [{ required: true, message: "请选择所属客户", trigger: "blur" }],
        InterfaceUrl: [{ required: true, message: "请输入接口Url", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CustomerId: [{ required: true, message: "请选择所属客户", trigger: "blur" }],
        InterfaceUrl: [{ required: true, message: "请输入接口Url", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CustomerId: 0,
        InterfaceUrl: "",
        InterfaceDescribe: "",
        Enabled: "true"
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CustomerId: "",
        InterfaceUrl: "",
        InterfaceDescribe: "",
        Enabled: "false"
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        customerId: item.customerId,
        enabled: item.enabled
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getCustomerInterface();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCustomerInterface();
    },
    queryCustomerInterface() {
      this.page = 1;
      this.getCustomerInterface();
    },
    //获取客户接口列表
    getCustomerInterface() {
      let _this = this;
      let para = {
        customerId: _this.filters.customerId,
        enabled: _this.filters.enabled,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getCustomerInterfaceListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.customerInterfaceList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeCustomerInterface(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getCustomerInterface();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CustomerId: "",
        Enabled: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editCustomerInterface(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getCustomerInterface();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addCustomerInterface(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getCustomerInterface();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getCustomerInterface();

     getCustomerListPage().then(res => {
      this.customerList = res.data.response.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
